import { getRequest, postRequest } from "../../shared/api/axiosHandler";

export const requestGuestCoupon = async (phoneNumber) => {
  try {
    return await postRequest('/public/coupon/guest', { phoneNumber });
  } catch (error) {
    throw error;
  }
};

export const validateGuestCoupon = async (phoneNumber, couponCode) => {
  try {
    return await postRequest('/public/coupon/guest/validate', { phoneNumber, couponCode });
  } catch (error) {
    throw error;
  }
};

// Coupon responses are reused for a few minutes per signed-in session (the cart
// refetches the coupon list on every change). Only successful responses are
// kept, and the cache is cleared after an order is placed or on logout.
const COUPON_CACHE_KEY = "couponCache";
const COUPON_CACHE_MS = 5 * 60 * 1000;
const couponRequests = new Map();

const couponCacheOwner = () => (localStorage.getItem("accessToken") || "").slice(-32);

const readCouponCache = () => {
  try {
    const cache = JSON.parse(sessionStorage.getItem(COUPON_CACHE_KEY));
    if (cache && cache.owner === couponCacheOwner()) return cache;
  } catch (error) {
    // Unreadable: start a new cache.
  }
  return { owner: couponCacheOwner(), entries: {} };
};

const cachedCouponRequest = (key, request) => {
  const entry = readCouponCache().entries[key];
  if (entry && Date.now() - entry.fetchedAt < COUPON_CACHE_MS) {
    return Promise.resolve(entry.data);
  }
  if (!couponRequests.has(key)) {
    couponRequests.set(
      key,
      request()
        .then((data) => {
          const cache = readCouponCache();
          cache.entries[key] = { data, fetchedAt: Date.now() };
          try {
            sessionStorage.setItem(COUPON_CACHE_KEY, JSON.stringify(cache));
          } catch (error) {
            // Storage unavailable: the response is still returned.
          }
          return data;
        })
        .finally(() => couponRequests.delete(key))
    );
  }
  return couponRequests.get(key);
};

export const clearCouponCache = () => {
  couponRequests.clear();
  try {
    sessionStorage.removeItem(COUPON_CACHE_KEY);
  } catch (error) {
    // Nothing to clear.
  }
};

export const getCoupondetails = async (couponCode) => {
    try {
      return await cachedCouponRequest(`check:${couponCode}`, () =>
        getRequest(`/api/v1/coupon/check?couponCode=${encodeURIComponent(couponCode)}`, {}, true)
      );
    } catch (error) {
      throw error;
    }
  };

export const getAvailableCoupons = async () => {
    try {
        return await cachedCouponRequest("available", () =>
          getRequest("/api/v1/coupon/get-coupons", {}, true)
        );
    } catch (error) {
        throw error;
    }
};
